<template>
  <section
    class="flex flex-col-reverse gap-16 lg:flex-row lg:flex-nowrap py-24"
  >
    <div class="flex flex-col w-full lg:w-1/2 lg:order-1">
      <AppUsp class="hidden lg:block" :items="uspItems" usp-direction="col" />
      <FamilyInfoBoxCompact />
      <p>
        Behöver du en ny mobil också?
        <NuxtLink to="/mobiltelefoner" external>Se våra telefoner här</NuxtLink>
      </p>
    </div>
    <div class="flex flex-col w-full lg:w-1/2 lg:order-2">
      <AppUsp class="lg:hidden mb-16" :items="uspItems" usp-direction="col" />
      <FamilyConfigurationMain />
    </div>
  </section>
  <FamilyDrawer />
</template>

<script lang="ts" setup>
import FamilyDrawer from '~/components/family/Drawer.vue';

interface Props {
  configData?: {
    UspItems?: {
      Icon?: string;
      Label?: string;
      SubLabel?: string;
    }[];
  };
}

const props = defineProps<Props>();

const uspItems = computed(() =>
  props.configData?.UspItems && Array.isArray(props.configData?.UspItems)
    ? props.configData.UspItems.map((item) => ({
        Icon: item.Icon || '',
        Label: item.Label || '',
        SubLabel: item.SubLabel,
      }))
    : [],
);
</script>

<style scoped></style>
